import I18n from 'I18n';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
import { useAdditionalPropertyValues } from '../v2/hooks/useAdditionalPropertyValues';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const OverdueWrapper = styled.span.withConfig({
  displayName: "FormattedInvoiceDueDate__OverdueWrapper",
  componentId: "qehlni-0"
})(["color:", ";"], CANDY_APPLE);
const OPEN = 'open';
const NATIVE_INVOICE = 'native_invoice';
const DATA_SYNC = 'data_sync';
const FormattedInvoiceDueDate = ({
  property,
  value,
  dateFormat,
  dateTimeFormat,
  relativeDate,
  relativeDateTime,
  objectTypeId
}) => {
  // hs_invoice_source: https://tools.hubteam.com/puma/objects/INVOICE/properties/hs_invoice_source/details
  // hs_invoice_status: https://tools.hubteam.com/puma/objects/INVOICE/properties/hs_invoice_status/details
  const {
    data: additionalValues,
    loading: additionalValuesLoading
  } = useAdditionalPropertyValues({
    invoiceSource: 'hs_invoice_source',
    invoiceStatus: 'hs_invoice_status'
  });
  if (value === null || value === undefined || value === '' || additionalValuesLoading || additionalValues === undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  const {
    invoiceSource,
    invoiceStatus
  } = additionalValues;
  const shouldDisplayAsOverDue = invoiceStatus === OPEN && (invoiceSource === NATIVE_INVOICE || invoiceSource === DATA_SYNC) && I18n.moment.utc(Number(value)).diff(I18n.moment.now()) < 0;
  const displayedValue = getDisplayedValue(property, value, undefined, {
    dateFormat,
    dateTimeFormat,
    relativeDate,
    relativeDateTime
  }, objectTypeId);
  return shouldDisplayAsOverDue ? /*#__PURE__*/_jsx(OverdueWrapper, {
    "data-test-id": "invoice-due-date-overdue-wrapper",
    children: displayedValue
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: displayedValue
  });
};
export default FormattedInvoiceDueDate;